import { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { GlobalProvider } from '@/shared/contexts/GlobalContext';
import { EmbedAuthProvider } from '@/shared/contexts/EmbedAuthContext';
import ChatLayout from '@/components/layout/ChatLayout';
import ChatPage from '@/components/chat/ChatWindow';

function App() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <GlobalProvider>
        <EmbedAuthProvider>
          <Routes>
            <Route element={<ChatLayout />}>
              <Route path="/" element={<ChatPage />} />
              <Route path="/chat/:threadId" element={<ChatPage />} />
            </Route>
          </Routes>
          <Toaster position="top-right" />
        </EmbedAuthProvider>
      </GlobalProvider>
    </Suspense>
  );
}

export default App;
